import { configureStore } from "@reduxjs/toolkit";

// Website
import website from "./website";

import internship from "./internship";

import blog from "./blog";

//store
export const store = configureStore({
  reducer: {
    website,

    internship,

    blog,
  },
});
